// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/components/timelineStyle.js";
import cx from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(styles);

export default function SingleColumnDetailVisualizer(props) {
  const classes = useStyles();
  const { details, simple } = props;
  const timelineClass =
    classes.timelineWithoutLine +
    " " +
    cx({
      [classes.timelineSimpleWithoutLine]: simple
    });
  return (
    <GridContainer xs={12} sm={12} md={12}>
      <GridItem xs={12} sm={12} md={12}>
        <ul className={timelineClass}>
          {details.map((prop, key) => {
            const panelClasses =
              classes.timelinePanelSingleColumn +
              " " +
              cx({
                [classes.timelineSingleColumnPanelInverted]: prop.inverted || simple,
                [classes.timelineSingleColumnSimplePanel]: simple
              });
            const timelineBadgeClasses =
              classes.timelineSingleColumnBadge +
              " " +
              " " +
              cx({
                [classes.timelineSingleColumnSimpleBadge]: simple
              });
            return (
              <li className={classes.item} key={key}>
              <div className={timelineBadgeClasses}>

              {/*
                    <CommonCustomIcon icon={"Soci"}/>
                  {(prop.title && showTitles) ? 
                    ( <span >{prop.title}</span> ) : null
                  }
                */}
              </div>      
                <div className={panelClasses}>
                  <div className={classes.timelineBody}>{prop.body}</div>
                  {prop.footerTitle ? (
                    <h6 className={classes.footerTitle}>{prop.footerTitle}</h6>
                  ) : null}
                  {prop.footer ? <hr className={classes.footerLine} /> : null}
                  {prop.footer ? (
                    <div className={classes.timelineFooter}>{prop.footer}</div>
                  ) : null}
                </div>
              </li>
            );
          })}
        </ul>
      </GridItem>
    </GridContainer>    
  );
}

SingleColumnDetailVisualizer.propTypes = {
  details: PropTypes.arrayOf(PropTypes.object).isRequired,
  simple: PropTypes.bool,
  showIcons: PropTypes.bool,
  showTitles: PropTypes.bool
};
